export default __webpack_public_path__ + "static/media/83.a92b14fa.jpg";